<div class="aligner-start w-full fixed-height">
  <y42-data-test-result-icon [status]="state.status" [errorMessages]="state.errorMessages"></y42-data-test-result-icon>
</div>
